<div class="p-0">
  <app-queue-list
    *ngIf="viewMode === 'list'"
    [reloadVersion]="reloadVersion"
    (newQueue)="openNewQueue()"
    (editQueue)="openEditQueue($event)" />

  <app-queue-form
    *ngIf="viewMode === 'form'"
    [queueId]="selectedQueueId"
    (saved)="onSaved()"
    (cancelled)="onCancelled()" />
</div>
